export default __webpack_public_path__ + "static/media/helloIllustration.3f89d786.svg";